import { jwtToken_PPP } from "../constant/Constants";
import { getJwtToken, getOAuthToken } from "./API/supertokenServices";
import Session from "supertokens-web-js/recipe/session";

let TIME_REMAINING = 2700000
let sessionRunning;
let extendSession;

export function resetSessionTiming() {
    TIME_REMAINING = 2700000
}

export default function sessionManagement(setExtendSession, setLogoutSession, setInterval, clearInterval, setSessioExtendAPI, email, checkIfSessionIsActive,setAutoExit,rememberMeFlag) {
    sessionRunning = setInterval(async () => {
        TIME_REMAINING = TIME_REMAINING - 10000;
        if (TIME_REMAINING <= 500 && TIME_REMAINING >= 0) {
            setExtendSession(true)
        }

        if (TIME_REMAINING < -115000) {
            //logout API
            clearInterval(sessionRunning)
            clearInterval(extendSession)
            rememberMeFlag != true && await Session.signOut()
            setLogoutSession(true)
            setExtendSession(false)
            setAutoExit(true)
        }
    }, 10000)
    extendSession = setInterval(async () => {
        await checkIfSessionIsActive()
    }, 1800000)
}

export const extend = (setExtendSession) => {
    setExtendSession(false)
    TIME_REMAINING = 2700000
}

export const exit = async (setExtendSession, setLogoutSession, clearInterval, rememberMeFlag) => {
    clearInterval(sessionRunning)
    clearInterval(extendSession)
    rememberMeFlag != true && await Session.signOut()
    setExtendSession(false)
    setLogoutSession(true)
}

export const setIntervalClosing = (clearInterval) => {
    clearInterval(sessionRunning)
    clearInterval(extendSession)
}